const fileName = (url) => {
  return url.split(/([\\/])/g).pop();
};

export default fileName;
